import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SpaDataContext = createContext({ therapists: [], massages: [], spacePhotos: [], banners: [], loading: true });

export const SpaDataProvider = ({ children }) => {
  const [state, setState] = useState({ therapists: [], massages: [], spacePhotos: [], banners: [], loading: true });

  useEffect(() => {
    Promise.all([
      axios.get(`${API}/therapists`),
      axios.get(`${API}/massages`),
      axios.get(`${API}/space-photos`).catch(() => ({ data: [] })),
      axios.get(`${API}/banners`).catch(() => ({ data: [] })),
    ])
      .then(([t, m, s, b]) =>
        setState({ therapists: t.data, massages: m.data, spacePhotos: s.data || [], banners: b.data || [], loading: false }),
      )
      .catch((e) => {
        console.error("Failed to load spa data", e);
        setState((s) => ({ ...s, loading: false }));
      });
  }, []);

  return <SpaDataContext.Provider value={state}>{children}</SpaDataContext.Provider>;
};

export const useSpaData = () => useContext(SpaDataContext);
